var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOn32X32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7379 17.9694C18.0349 18.7174 18.1999 19.5424 18.1999 20.4005C18.1999 22.3475 17.3529 24.1076 15.9999 25.3066C14.7958 26.4002 13.2265 27.0043 11.5999 27.0007C7.95897 27.0007 5 24.0416 5 20.4005C5 17.3644 7.06798 14.7903 9.86196 14.0312",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7379 17.9694C18.0349 18.7174 18.1999 19.5424 18.1999 20.4005C18.1999 22.3475 17.3529 24.1076 15.9999 25.3066C14.7958 26.4002 13.2265 27.0043 11.5999 27.0007C7.95897 27.0007 5 24.0416 5 20.4005C5 17.3644 7.06798 14.7903 9.86196 14.0312",
    stroke: "#222222",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7913 14.6826C21.6597 14.2626 22.6752 14.1273 23.524 14.5855C25.5893 15.7005 26.9999 17.8929 26.9999 20.4005C26.9999 24.0416 24.0409 27.0007 20.4 27.0007C19.3693 27.003 18.3617 26.7613 17.4554 26.3057",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7913 14.6826C21.6597 14.2626 22.6752 14.1273 23.524 14.5855C25.5893 15.7005 26.9999 17.8929 26.9999 20.4005C26.9999 24.0416 24.0409 27.0007 20.4 27.0007C19.3693 27.003 18.3617 26.7613 17.4554 26.3057C16.4479 25.7992 16 24.6636 16 23.5359V19.5086C16 17.9746 16.8773 16.5757 18.2583 15.9077L20.7913 14.6826Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7913 14.6826C21.6597 14.2626 22.6752 14.1273 23.524 14.5855C25.5893 15.7005 26.9999 17.8929 26.9999 20.4005C26.9999 24.0416 24.0409 27.0007 20.4 27.0007C19.3693 27.003 18.3617 26.7613 17.4554 26.3057",
    stroke: "#222222",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7913 14.6826C21.6597 14.2626 22.6752 14.1273 23.524 14.5855C25.5893 15.7005 26.9999 17.8929 26.9999 20.4005C26.9999 24.0416 24.0409 27.0007 20.4 27.0007C19.3693 27.003 18.3617 26.7613 17.4554 26.3057C16.4479 25.7992 16 24.6636 16 23.5359V19.5086C16 17.9746 16.8773 16.5757 18.2583 15.9077L20.7913 14.6826Z",
    stroke: "#222222",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40039 11.6002C9.40039 13.3507 10.0957 15.0295 11.3335 16.2673C12.5712 17.505 14.2499 18.2004 16.0003 18.2004C17.7507 18.2004 19.4295 17.505 20.6672 16.2673C21.9049 15.0295 22.6003 13.3507 22.6003 11.6002C22.6003 9.84972 21.9049 8.17094 20.6672 6.93316C19.4295 5.69538 17.7507 5 16.0003 5C14.2499 5 12.5712 5.69538 11.3335 6.93316C10.0957 8.17094 9.40039 9.84972 9.40039 11.6002Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOn32X32);
export default __webpack_public_path__ + "static/media/filter_on_32x32.9d412feac13760f67f68bb524058a169.svg";
export { ForwardRef as ReactComponent };